import { render, staticRenderFns } from "./AuthorizedLinks.vue?vue&type=template&id=761a2ce7&"
import script from "./AuthorizedLinks.vue?vue&type=script&lang=ts&"
export * from "./AuthorizedLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports